import { useMemo } from "react";

import type {
  ScreenMembersOnSignup,
  SignupOptions,
} from "@auth0/auth0-acul-js/signup";
import SignupInstance from "@auth0/auth0-acul-js/signup";

import { executeSafely } from "../utils/helpers/executeSafely";

export const useSignupManager = () => {
  const signupInstance = useMemo(() => new SignupInstance(), []);

  const { transaction, screen } = signupInstance;
  const {
    requiredIdentifiers,
    optionalIdentifiers,
    passwordPolicy,
    usernamePolicy,
    alternateConnections,
    isPasskeyEnabled,
  } = transaction;
  const { loginLink, texts, captchaImage } = screen;

  const handleSignup = async (options: SignupOptions): Promise<void> => {
    const safeOptions = { ...options };
    if (safeOptions.password) {
      safeOptions.password = "********";
    }

    executeSafely(
      `Signup with options: ${JSON.stringify(safeOptions)}`,
      () => signupInstance.signup(options)
    );
  };

  const handleFederatedSignup = async (connectionName: string) => {
    executeSafely(
      `Federated signup with connection: ${connectionName}`,
      () => signupInstance.federatedSignup({ connection: connectionName })
    );
  };

  return {
    signupInstance,
    handleSignup,
    handleFederatedSignup,
    texts: (texts || {}) as ScreenMembersOnSignup["texts"],
    errors: signupInstance.getError(),
    isCaptchaAvailable: screen.isCaptchaAvailable === true,
    captchaImage,
    requiredIdentifiers: requiredIdentifiers ?? [],
    optionalIdentifiers: optionalIdentifiers ?? [],
    passwordPolicy,
    usernamePolicy,
    alternateConnections: alternateConnections ?? [],
    isPasskeyEnabled: isPasskeyEnabled === true,
    loginLink,
  };
};
